import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {ReactiveFormsModule} from '@angular/forms';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {ItemRequestsSelectors} from '@store/item-requests/item-requests.selectors';
import {DISPLAYABLE_ITEM_REQUEST_STATUS, ITEM_REQUEST_STATUS_CHIP_COLORS, ItemRequest} from '@store/item-requests/item-requests.types';
import {MatChipSet} from '@angular/material/chips';
import {StatusChipComponent} from '@aviary/components/status-chip/status-chip.component';
import {DetailFieldComponent} from '@aviary/components/detail-field/detail-field.component';
import {DetailFieldDefaultsDirective} from '@aviary/components/detail-field/detail-field-defaults/detail-field-defaults.directive';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {CoverImageComponent} from '@aviary/components/cover-image/cover-image.component';
import {
  ItemRequestDetailsMessagesComponent
} from '@app/my-account/item-requests/item-request-details/item-request-details-messages/item-request-details-messages.component';
import {FALLBACK_ITEM_REQUEST} from '@store/item-requests/item-requests.fallback';
import {ExpandableCardComponent} from '@aviary/components/expandable-card/expandable-card.component';
import {ExpandableCardToggleButtonComponent} from '@aviary/components/expandable-card/expandable-card-toggle-button/expandable-card-toggle-button.component';
import {MatExpansionPanelState} from '@angular/material/expansion';
import {NgTemplateOutlet} from '@angular/common';
import {ItemRequestsActions} from '@store/item-requests/item-requests.actions';
import {isPositiveNumber} from '@aviary/store/common/typing.helpers';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';

@Component({
  selector: 'px-item-request-details',
  templateUrl: './item-request-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCardTitle, MatCard, MatCardContent, ReactiveFormsModule, FormatPipe, SelectPipe, HiddenUntilLoadedDirective, MatChipSet, StatusChipComponent,
    DetailFieldComponent, DetailFieldDefaultsDirective, CoverImageComponent, ItemRequestDetailsMessagesComponent, ExpandableCardComponent,
    ExpandableCardToggleButtonComponent, NgTemplateOutlet, ButtonRouteNameDirective, IconButtonComponent, FilledButtonComponent
  ]
})
export class ItemRequestDetailsComponent {
  private readonly store: Store = inject(Store);
  public readonly currentSelectors = ItemRequestsSelectors.Current;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly chipColors = ITEM_REQUEST_STATUS_CHIP_COLORS;
  public readonly emptyRequest = FALLBACK_ITEM_REQUEST;
  public readonly chipNames = DISPLAYABLE_ITEM_REQUEST_STATUS;

  public catalogRecordExpansionState: MatExpansionPanelState = 'collapsed';
  public itemRequestExpansionState: MatExpansionPanelState = 'collapsed';
  public messagesExpansionState: MatExpansionPanelState = 'collapsed';

  public onClickCancel(itemRequest?: ItemRequest): void {
    if (itemRequest && isPositiveNumber(itemRequest.id)) {
      this.store.dispatch(ItemRequestsActions.showCancelItemRequest(itemRequest))
    }
  }
}
